<template>
    <div :style="{ width: boxWidth, ...wrapStyle }">
        <el-timeline>
            <el-timeline-item v-for="(item, index) in cardlist" :key="index" :timestamp="item.timestamp" placement="top"
                ref="timelineItem">
                <el-card @click.native="handleCardClick(index, item)" :class='{ active: index === number}'>
                    <base-label style=" overflow-wrap: break-word;white-space: normal;" :label="`${appeal_descTitle}：${item.appeal_desc}`" label-position="top"
                        class="block"></base-label>
                    <base-label :label="`${appeal_file_title}：`" label-position="top" class="block"></base-label>
                    <base-filelist :filelist="item.photos" />
                    <el-divider v-if="item.appeal_dispose_desc != '' && item.appeal_dispose_desc != undefined" class="block"
                        content-position="left">{{ divider_title }}</el-divider>
                    <base-label  v-if="item.appeal_result != '' && item.appeal_result != undefined"
                        :label="`处理结果：${item.appeal_result}`" label-position="top" class="block"></base-label>
                    <base-label style=" overflow-wrap: break-word;white-space: normal;" v-if="item.appeal_result != '' && item.appeal_result != undefined"
                        :label="`处理说明：${item.appeal_dispose_desc}`" label-position="top" class="block"></base-label>
                    <base-label v-if="item.appeal_result != '' && item.appeal_result != undefined" :label="'处理材料：'"
                        label-position="top" class="block"></base-label>
                    <base-filelist :filelist="item.dispose_photos" />
                    <el-divider v-if="item.appeal_final_result != '' && item.appeal_final_result != undefined" class="block"
                    content-position="left">{{ '终审结果' }}</el-divider>
                    <base-label  v-if="item.appeal_final_result != '' && item.appeal_final_result != undefined"
                        :label="`终审结果：${item.appeal_dispose_text}`" label-position="top" class="block"></base-label>
                    <base-label style=" overflow-wrap: break-word;white-space: normal;" v-if="item.appeal_edit_result != '' && item.appeal_edit_result != undefined"
                        :label="`修改判分说明：${item.appeal_edit_text}`" label-position="top" class="block"></base-label>
                    <base-label style=" overflow-wrap: break-word;white-space: normal;" v-if="item.appeal_final_desc != '' && item.appeal_final_desc != undefined"
                        :label="`终审说明：${item.appeal_final_desc}`" label-position="top" class="block"></base-label>
                </el-card>
            </el-timeline-item>
        </el-timeline>
    </div>
</template>
<script>
export default {
    name: 'BaseTimeline',
    inheritAttrs: false,
    props: {
        cardlist: {
            type: Array,
            default: () => []
        },
        width: [String, Number],
        gutter: {
            type: Number,
            default: 0
        },
        appealnumber: {
            type: Number,
            default: -1
        },
        appeal_descTitle: {
            type: String,
            default: '申诉说明'
        },
        appeal_file_title: {
            type: String,
            default: '辅助证明材料'
        },
        divider_title: {
            type: String,
            default: '初审结果'
        }
    },

    data(){
        return {
            number: -1
        }
    },
    init(){
        this.number = this.appealnumber;
    },
    methods: {
        handleCardClick(index, item) {
            if (this.number == index) {
                this.number = -1;
                this.$emit('cardClick', '');
            } else {
                this.number= index;
                this.$emit('cardClick', item);
            }

        },
        Cancel() {
            this.number = -1;
            this.$emit('cardClick', '');
        }
    },
    computed: {
        boxWidth() {
            return /^\d+(\.\d+)?$/.test(String(this.width)) ? `${this.width}px` : this.width
        },
        wrapStyle() {
            if (this.gutter > 0) {
                const padding = Math.floor(this.gutter / 2) + 'px'
                return {
                    padding: `0 ${padding} ${padding}`
                }
            }
            return {}
        }
    }
}
</script>
<style lang="scss">
.active {
    border: 1px solid #6D83BC;
    padding-left: 6px;
    padding-top: 6px;
}</style>